export const toggleIsDesktop = isDesktop => {
  return {
    type: 'TOGGLE_IS_DESKTOP',
    isDesktop
  };
};
